module.exports = __webpack_public_path__ + "img/icon.8a0d0a4.png";